var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fm_display_simple"}},[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('fm_result_container',{attrs:{"show_results_per_page_selector":_vm.show_results_per_page_selector,"resultColumns":_vm.resultColumns}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }